import { useLayoutEffect, useRef } from 'react';

/**
 * Scrolls the scrolled ancestors of the returned ref's element back to the top
 * whenever `key` changes, for views that take turns inside one scrolling area
 * (a dashboard tab's list, form and detail page). Without it the next view
 * opens at the last one's offset: after "Create", the new plan's page would
 * start halfway down. The first render scrolls nothing.
 */
export function useScrollTopOnChange<T extends HTMLElement>(key: string) {
  const ref = useRef<T>(null);
  const lastKey = useRef(key);
  useLayoutEffect(() => {
    if (lastKey.current === key) return;
    lastKey.current = key;
    for (let node = ref.current?.parentElement ?? null; node; node = node.parentElement) {
      if (node.scrollTop > 0) node.scrollTop = 0;
    }
  }, [key]);
  return ref;
}
